import { render, staticRenderFns } from "./tableClickCunstom.vue?vue&type=template&id=574a9efc"
import script from "./tableClickCunstom.vue?vue&type=script&lang=js"
export * from "./tableClickCunstom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports